import React from "react";
import styled from "styled-components";

const ContainerWrapper = styled.section`
  padding: 24px 24px 0;
`;

const Container = ({ children }) => (
  <ContainerWrapper>{children}</ContainerWrapper>
);

export default Container;
export { default as TitleGoBack } from "./titleGoBack";
